export default __webpack_public_path__ + "static/media/submitBackgroundXXXL.99af9a76.svg";